import { useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/daf8kl1tto0ceqqnh810";

type Status = "idle" | "loading" | "success" | "error";

const topics = ["新闻线索", "投稿纠错", "栏目建议", "合作洽谈", "其他"];

function ContactForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [formError, setFormError] = useState("");
  const [messageLen, setMessageLen] = useState(0);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const honeypot = String(data.get("contact_alt") || "").trim();
    setFormError("");

    if (honeypot) {
      form.reset();
      setMessageLen(0);
      setStatus("success");
      return;
    }
    data.delete("contact_alt");

    setStatus("loading");
    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const meta = parsed?.meta as Record<string, unknown> | undefined;
      const message = meta?.message || parsed?.message || meta?.detail || responseText;
      const code = parsed?.code;
      const isSpam = /spam/i.test(String(message || ""));

      if (res.ok && code === "OK" && !isSpam) {
        form.reset();
        setMessageLen(0);
        setStatus("success");
      } else {
        setStatus("error");
        setFormError(String(message || "提交失败，请稍后再试"));
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后再试");
    }
  }

  const inputCls =
    "w-full rounded-md border border-background-200 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200";

  return (
    <form id="contact-form" data-readdy-form="daf8kl1tto0ceqqnh810" onSubmit={handleSubmit} noValidate>
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="contact-name" className="mb-1.5 block text-sm font-medium text-foreground-800">
            你的称呼 <span className="text-primary-500">*</span>
          </label>
          <input id="contact-name" name="name" required maxLength={30} className={inputCls} placeholder="如何称呼你" />
        </div>
        <div>
          <label htmlFor="contact-email" className="mb-1.5 block text-sm font-medium text-foreground-800">
            邮箱 <span className="text-primary-500">*</span>
          </label>
          <input
            id="contact-email"
            name="email"
            type="email"
            required
            maxLength={80}
            className={inputCls}
            placeholder="用于接收回复"
          />
        </div>
      </div>

      <div className="mt-4">
        <label htmlFor="contact-topic" className="mb-1.5 block text-sm font-medium text-foreground-800">
          来信主题
        </label>
        <select id="contact-topic" name="topic" className={inputCls} defaultValue="新闻线索">
          {topics.map((t) => (
            <option key={t} value={t}>
              {t}
            </option>
          ))}
        </select>
      </div>

      <div className="mt-4">
        <div className="mb-1.5 flex items-center justify-between">
          <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800">
            留言内容 <span className="text-primary-500">*</span>
          </label>
          <span className={`text-xs ${messageLen >= 500 ? "text-primary-600" : "text-foreground-400"}`}>
            {messageLen} / 500
          </span>
        </div>
        <textarea
          id="contact-message"
          name="message"
          required
          rows={5}
          maxLength={500}
          onChange={(e) => setMessageLen(e.target.value.length)}
          className={`${inputCls} resize-none`}
          placeholder="请描述你的线索、问题或建议…"
        />
      </div>

      {/* 反垃圾蜜罐字段 */}
      <label className="contact-website">
        备用电话
        <input type="text" name="contact_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
      </label>

      <div className="mt-5">
        <button
          type="submit"
          disabled={status === "loading"}
          className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-70"
        >
          {status === "loading" ? "提交中…" : "提交留言"}
        </button>
      </div>

      <p className="mt-3 text-sm" role="status" aria-live="polite">
        {status === "success" && (
          <span className="inline-flex items-center gap-1.5 text-secondary-700">
            <i className="ri-checkbox-circle-line" /> 提交成功，我们会尽快与你联系。
          </span>
        )}
        {status === "error" && (
          <span className="inline-flex items-center gap-1.5 text-primary-600">
            <i className="ri-error-warning-line" /> {formError}
          </span>
        )}
      </p>
    </form>
  );
}

export default ContactForm;